import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrdenesVentaComponent } from './ordenes-venta.component';
import { Routes, RouterModule } from '@angular/router';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MaterialModule } from '../../../components/material/material.module';
import { BotonToggleModule } from '../../../components/boton/boton-toggle.module';
import { OrdenVentaModule } from '../../../forms/orden-venta/orden-venta.module';
import { BotonActionModule } from '../../../components/boton-action/boton-action.module';

const routes: Routes = [
  {
    path: '',
    component: OrdenesVentaComponent
  },
  {
    path: 'detalle-ov/:id',
    loadChildren: 'app/pages/logueado/ordenes-venta/detalle-ov/detalle-ov.module#DetalleOvModule'
  },
];

@NgModule({
  declarations: [
    OrdenesVentaComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    NgxPermissionsModule.forChild(),
    MaterialModule,
    BotonToggleModule,
    OrdenVentaModule,
    BotonActionModule,
  ]
})
export class OrdenesVentaModule { }
